import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import toastr from "toastr";
import Constants from '../../../../classes/constants';
import ProfilePhoto from "../../../../components/common/ProfilePhoto";


function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  // fieldValue is column value
  // row is whole row object
  // rowIdx is index of row
  // colIdx is index of column
  if (row.empStatus == "R")
    return 'color2';
  else if (row.empStatus == "P")
    return 'color5';

  else
    return rowIdx % 2 == 0 ? 'color' : 'td-column-function-odd-example';
}
function enumFormatter(cell, row, enumObject) {
  return enumObject[cell];
}
class EmployeeTable extends React.Component {

  constructor() {
    super();
    this.state = {products: [], openExit: false, openEdit: false};
  }

  renderShowsTotal(start, to, total) {
    return (

      <p style={ {marginTop: '10px', color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {
    const departmentType = {
      "1800 Miss Call": "1800 Miss Call",
      "3D Development": "3D Development",
      "Account Management": "Account Management",
      "Ad Monetisation": "Ad Monetisation",
      "AD_Posting": "AD_Posting",
      "Admin": "Admin",
      "Analytics": "Analytics",
      "Application Development": "Application Development",
      "Bike Calling": "Bike Calling",
      "Bike_Process": "Bike_Process",
      "Bike_Procurement": "Bike_Procurement",
      "Bike_Selling": "Bike_Selling",
      "Branch Sales": "Branch Sales",
      "Brand Marketing": "Brand Marketing",
      "Business Intelligence": "Business Intelligence",
      "Business Tools": "Business Tools",
      "Caller": "Caller",
      "Car Inspection": "Car Inspection",
      "Car Verified Leads": "Car Verified Leads",
      "Channel Partner": "Channel Partner",
      "Channel Partners": "Channel Partners",
      "Chat": "Chat",
      "Client Onboarding": "Client Onboarding",
      "Content Moderation": "Content Moderation",
      "Content Research": "Content Research",
      "Content Review": "Content Review",
      "Content Tools": "Content Tools",
      "Corporate Sales": "Corporate Sales",
      "Customer Service": "Customer Service",
      "Customer Support": "Customer Support",
      "Customer Support - TL": "Customer Support - TL",
      "Cutomer Service": "Cutomer Service",
      "Data Entry": "Data Entry",
      "Data Mining": "Data Mining",
      "Dealer Procurement Program (DPP)": "Dealer Procurement Program (DPP)",
      "Delivery Ops": "Delivery Ops",
      "Design": "Design",
      "Digital Marketing": "Digital Marketing",
      "Digital Marketing - SEM": "Digital Marketing - SEM",
      "Digital Marketing - SEO": "Digital Marketing - SEO",
      "Direct Sales": "Direct Sales",
      "Email Support": "Email Support",
      "Engagement Management": "Engagement Management",
      "Executive Assistant": "Executive Assistant",
      "Finance and Accounts": "Finance and Accounts",
      "FOS": "FOS",
      "FOS - R2": "FOS - R2",
      "FOS - R3": "FOS - R3",
      "Groups": "Groups",
      "H2H": "H2H",
      "Hiring": "Hiring",
      "HR Operations": "HR Operations",
      "HRBP": "HRBP",
      "Human Resource": "Human Resource",
      "Implementation - R2": "Implementation - R2",
      "Implementation - R3": "Implementation - R3",
      "Inspection Calling": "Inspection Calling",
      "Inspection monitization": "Inspection monitization",
      "IRX": "IRX",
      "IT": "IT",
      "IT Infra": "IT Infra",
      "Lead generation": "Lead generation",
      "Listing Ops": "Listing Ops",
      "Logistics": "Logistics",
      "Marketing": "Marketing",
      "MGMT": "MGMT",
      "MIS": "MIS",
      "Mobile Apps": "Mobile Apps",
      "Mobile Development": "Mobile Development",
      "OBD_Services": "OBD_Services",
      "Office Boy": "Office Boy",
      "OMS": "OMS",
      "On-Demand Services": "On-Demand Services",
      "Operations": "Operations",
      "Payment": "Payment",
      "PKHD/HomeVision": "PKHD/HomeVision",
      "PLV": "PLV",
      "Post AD Drop cailing": "Post AD Drop cailing",
      "Product": "Product",
      "Product Monetization": "Product Monetization",
      "Project Management": "Project Management",
      "Project Ops": "Project Ops",
      "Public Relations": "Public Relations",
      "QA-CR": "QA-CR",
      "Quality": "Quality",
      "Quality Assurance": "Quality Assurance",
      "Quikr X": "Quikr X",
      "Quikr X - TL": "Quikr X - TL",
      "Quikr_Stepni": "Quikr_Stepni",
      "QuikrX": "QuikrX",
      "RE calling": "RE calling",
      "Regional HR": "Regional HR",
      "Renewal": "Renewal",
      "Replies": "Replies",
      "Retention": "Retention",
      "RTO Services": "RTO Services",
      "Sales": "Sales",
      "Sales Operations": "Sales Operations",
      "Scheduling": "Scheduling",
      "Scheduling / Payment": "Scheduling / Payment",
      "Service Provider Coordination": "Service Provider Coordination",
      "Service Provider Operations": "Service Provider Operations",
      "Service Seeker Operations": "Service Seeker Operations",
      "SFM": "SFM",
      "SFM - Ad Posting": "SFM - Ad Posting",
      "SFM - Escalations": "SFM - Escalations",
      "SFM - RM": "SFM - RM",
      "SFM & Scheduling": "SFM & Scheduling",
      "SFM- Ad Posting": "SFM- Ad Posting",
      "Social Media": "Social Media",
      "Social Media Support": "Social Media Support",
      "Stylist": "Stylist",
      "Technology": "Technology",
      "Telesales": "Telesales",
      "Testing": "Testing",
      "Trainer": "Trainer",
      "Training": "Training",
      "UED": "UED",
      "UI/UX Design": "UI/UX Design",
      "User Experience": "User Experience",
      "Web Development": "Web Development"
    };
    const locationType = this.props.constants.locationFilter;
    const functionType = Constants.functionType;
    const erpDepartmentType = Constants.erpDepartmentType;
    const verticalType = this.props.constants.verticalFilter;

    const subDepartmentType = Constants.subDepartmentType;

    const payrollType = this.props.constants.payrollFilter;
    const options = {
      clearSearch: true,

      sizePerPageList: ["5", "10", "20", "30", "40", "200"],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };
    return (
      <div>
        <BootstrapTable
          exportCSV={true}
          containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
          headerStyle={{
            borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
            , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
          }}
          tableStyle={{marginBottom: '5%', borderStyle: 'solid'}}
          maxHeight={600}
          data={this.props.employees}
          search={true}
          striped
          options={options}
          pagination>
          <TableHead
            isKey={false}
            hidden={false}
            columnClassName="leftRightOnlyZero"
            width={80}
            dataFormat={(cell, row)=> {
              return <div>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                  <img style={{cursor: 'pointer', display: 'inline'}}
                       onClick={()=> {

                         this.props.edit(row);
                         this.props.openEdit();
                       }}
                       src="/public/images/edit.png"></img>
                </OverlayTrigger>


                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Remove</Tooltip>}>
                  <img style={{cursor: 'pointer', display: 'inline', paddingLeft: '5px'}}
                       onClick={()=> {

                         if (row.empStatus == "R" || row.empStatus == "P") {
                           toastr.info("The employee is already in Exits.");
                           return;
                         }
                         let flag = confirm("Are you sure? The manager is supposed to raise a request for resignation")
                         if (flag == true) {
                           this.props.edit(row);
                           this.props.openExit();
                         }
                       }}
                       src="/public/images/error.png"></img>
                </OverlayTrigger>
              </div>

            }}
            dataField="empId"> </TableHead>
          <TableHead dataSort={true}
                     isKey={true}
                     hidden={false}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Id'} }
                     width={100}
                     dataFormat={(cell, row)=> {
                       return <a onClick={()=> {
                         console.log(row.empId);
                         this.props.openComplete(row.employeeCode);
                       }}>{cell}</a>
                     }}
                     columnClassName={ columnClassNameFormat }
                     dataField="employeeCode">Id</TableHead>
          <TableHead dataSort={true}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                     columnClassName={ columnClassNameFormat }
                     width={140} dataField="name"
                     dataFormat={(cell, row)=> {
                       return <OverlayTrigger trigger={['hover']} placement="top" overlay={<Popover>
                         <ProfilePhoto height="150px" width="150px" empno={row.employeeCode}/></Popover>}>
                         <a onClick={()=> {
                           this.props.edit(row);
                           this.props.openView();
                         } }
                         >{cell}</a>
                       </OverlayTrigger>
                     }}>Name</TableHead>
          <TableHead dataField="location"
                     filter={ {type: 'SelectFilter', options: locationType, placeholder: 'Location'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     width={120}>Location</TableHead>
          <TableHead dataField="payroll"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: payrollType, placeholder: 'Payroll'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={120}>Payroll</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Email'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="emailId">Email Id</TableHead>
          <TableHead dataField="managerName"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: "Manager Name"} }
                     dataFormat={(cell, row, formatExtraData, rowIdx)=> {
                       return cell;
                     }}
                     dataSort={true}
                     width={150}>Reporting to</TableHead>
          <TableHead dataField="reportingTo"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'ManagerId'} }
                     dataFormat={(cell, row, formatExtraData, rowIdx)=> {
                       return cell;
                     }}
                     dataSort={true}
                     width={120}>ManagerId</TableHead>

          <TableHead dataField="designation"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Designation'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={160}>Designation</TableHead>
          <TableHead dataField="department"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: departmentType, placeholder: 'Department'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>Department</TableHead>
          <TableHead dataField="subDepartment"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: subDepartmentType, placeholder: 'Sub Dept'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>Sub-Department</TableHead>
          <TableHead dataField="function"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: functionType, placeholder: 'Function'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>Function</TableHead>
          <TableHead dataField="erp_department"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: erpDepartmentType, placeholder: 'ERP Department'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>ERP Department</TableHead>

          <TableHead dataField="vertical"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: verticalType, placeholder: 'Vertical'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     hidden={false}
                     width={100}>Vertical</TableHead>
          <TableHead dataField="verticalHeadName"

                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', placeholder: 'Vertical head'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     hidden={false}
                     width={150}>Vertical Head</TableHead>
          <TableHead dataField="empStatus"

                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', placeholder: 'Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     hidden={false}
                     width={80}>Status</TableHead>

          <TableHead dataField="dateOfJoining"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'DateFilter', delay: 250} }
                     dataFormat={(cell)=> {
                       if (cell != null && cell != " " && cell != 0)
                         return <font>{cell}</font>
                       else
                         return 'NA';
                     }}
                     dataSort={true}
                     width={260}>Date of Joining</TableHead>
        </BootstrapTable>

      </div>
    );
  }
}

EmployeeTable.propTypes = {};

export default EmployeeTable;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/PeopleSearch/components/EmployeeTable.js
 **/